module.exports = __webpack_public_path__ + "static/media/mouse-icon.265b73f3.svg";